export default __webpack_public_path__ + "static/media/docker-icon.e2cb8d0f.svg";